module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/title_cover-c71682b2e4c56fc62d3c9561ccf25f94.jpg";